<div class="input-group">
    <input
        type="text"
        [(ngModel)]="filterValue"
        (keyup)="filterValueChange.emit(filterValue)"
        [placeholder]="placeholder"
        class="flex-1 input input-bordered"
    />
    <button class="btn btn-square" (click)="clear()">
        <iota-icon icon="x-mark"></iota-icon>
    </button>
</div>
